import Task from './Task';

const editPositionUrl    = '/staff_edit_position';

class PositionSaveTask extends Task {
  constructor(
    $q,
    APIService,
    LogService,
    DataSyncService,
    PositionService,
    DateTimeService
  ) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.LogService = LogService;
    this.DataSyncService = DataSyncService;
    this.PositionService = PositionService;
    this.DateTimeService = DateTimeService;

    this._position = null;
    this._serializedPosition = null;
  }

  get canExecute() {
    return this.APIService.isOnline;
  }
  get position(){
    return this._position;
  }

  set position(position) {
    this._position = position;
  }

  get serializedPosition(){
    return this._serializedPosition;
  }

  set serializedPosition(serializedPosition) {
    this._serializedPosition = serializedPosition;
  }

  populate(data){
    this.serializedPosition = data.serializedPosition;
  }

  serialize(){
    return {
      serializedPosition: this.serializedPosition
    };
  }

  execute() {
    this.LogService.info("PositionSaveTask.execute()");

    return this._savePosition()
      .then(savedPosition => {
        if (savedPosition){
          return savedPosition;
        }
      })
      .catch(err => {
        this.LogService.error("Error saving position:", err);
        return this.$q.reject(err);
      });
  }

  _savePosition() {
    const data = this.serializedPosition;

    // Convert at least a few of the dates to known good API format
    const convertDatetimeFields = [
      'start_time',
      'end_time',
    ];
    convertDatetimeFields.forEach(field => {
      if (data[field]) {
        data[field] = this.DateTimeService.serializeDateTimeForAPI(data[field]);
      }
    });

    return this.APIService.post(editPositionUrl, data);
  }
}

export default PositionSaveTask;
